<template>
  <div>
    <Head />
    <Navigation />
    <Wallpaper :src="src"/>
    <SecNav :to="to" :list="list"/>
    <Describe v-bind="$attrs"/>
    <foot />
    <BackTop :height="200" :bottom="100"></BackTop>
  </div>
</template>

<script>
import Head from '@/components/index/components/head'
import Wallpaper from '../components/wallpaper'
import Describe from '../components/describe'
import SecNav from '../components/breadcrumb'
import Foot from '@/components/index/components/foot'
import Navigation from '@/components/index/components/nav'
export default {
  name: 'Intros_mob',
  components: {
    Head,
    Foot,
    Navigation,
    Wallpaper,
    Describe,
    SecNav
  },
  data () {
    return {
      src: require('../components/wallpaper/5a7d0b8613cdf.jpg'),
      to: '/intros/mob_list',
      list: '企业简介'
    }
  }
}
</script>

<style scoped>

</style>
